<template>
  <div class="home-container" style="height: 100%">
    <MenuComponent />
    <HeaderComponent />
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderComponent from "../components/HeaderComponent.vue";
import MenuComponent from "../components/MenuComponent.vue";
import authService from "@/services/authService";
import router from "@/router";

export default defineComponent({
  name: "HomeView",
  components: {
    HeaderComponent,
    MenuComponent,
  },
  setup() {
    const token = localStorage.getItem("access_token") || "";
    const adminRoles = authService.getAdminRoles();
    const managerRoles = authService.getManagerRoles();
    const accountantRoles = authService.getAccountantRoles();
    const kindergartenHeadRoles = authService.getKindergartenHeadRoles();
    const finDirRoles = authService.getFinDirRoles();
    if (router.currentRoute.value.path === '/') {
      if (!token) {
        router.push('/login');
      }
      else if (authService.checkRoleAccessFromToken(token, [...adminRoles, ...managerRoles, ...accountantRoles])) {
        router.push("/directory");
      } else if (authService.checkRoleAccessFromToken(token, kindergartenHeadRoles)) {
        router.push("/report-sign");
      } else if (authService.checkRoleAccessFromToken(token, finDirRoles)) {
        router.push("/kindergarten-1c-act-reconciliation");
      }
    }
  }
});
</script>

<style scoped>
.home-container {
  display: flex;
}

.main-content {
  margin-left: 220px;
  margin-top: 60px;
  padding: 20px;
  width: calc(100% - 220px);
  background-color: #f5f7fa;
}
</style>
